<div class="rp-programs-container">
  <div *ngIf="loadFailed" class="rp-programs-error">
    {{ 'MENU_EDIT.RP_PROGRAM.LOAD_ERROR' | translate }}
  </div>

  <ng-container *ngIf="!loadFailed">
    <div *ngIf="hasProgram; else emptyState">
      <div class="button-group">
        <button *ngIf="hasMenuEdit$ | async" mat-raised-button color="primary" [disabled]="loading" (click)="submit()">
          {{ 'COMMON.APPLY' | translate }}
        </button>
        <button *ngIf="hasMenuEdit$ | async" mat-raised-button color="accent" [disabled]="loading" (click)="editDishesList()">
          {{ 'MENU_EDIT.RP_PROGRAM.EDIT_LIST' | translate }}
        </button>
        <button *ngIf="hasMenuDelete$ | async" mat-raised-button color="warn" [disabled]="loading" (click)="remove()">
          {{ 'COMMON.DELETE' | translate }}
        </button>
        <span *ngIf="loading" class="loading-indicator">
          {{ 'COMMON.LOADING' | translate }}
        </span>
      </div>

      <div *ngIf="saveFailed" class="rp-programs-error">
        {{ 'MENU_EDIT.RP_PROGRAM.SAVE_ERROR' | translate }}
      </div>

      <div *ngIf="!products.length && !loading" class="rp-programs-hint">
        {{ 'MENU_EDIT.RP_PROGRAM.NO_DISHES' | translate }}
      </div>

      <div class="dish-list">
        <app-promo-product-card *ngFor="let product of products"
                                [product]="product"
                                [currentOrganization]="organization">
        </app-promo-product-card>
      </div>
    </div>

    <ng-template #emptyState>
      <div class="rp-programs-empty">
        <p class="rp-programs-hint">{{ 'MENU_EDIT.RP_PROGRAM.EMPTY' | translate }}</p>
        <button *ngIf="hasMenuEdit$ | async" mat-raised-button color="primary" [disabled]="loading" (click)="create()">
          {{ 'COMMON.CREATE' | translate }}
        </button>
        <div *ngIf="saveFailed" class="rp-programs-error">
          {{ 'MENU_EDIT.RP_PROGRAM.SAVE_ERROR' | translate }}
        </div>
        <span *ngIf="loading" class="loading-indicator">
          {{ 'COMMON.LOADING' | translate }}
        </span>
      </div>
    </ng-template>
  </ng-container>
</div>
